const QUERY = '.site-preloader';
const DURATION = null;

/**
 * This feature is used to set preloader behavior
 * 
 * @class Preloader
 * @param {string} [query]
 * @param {number} [duration]
 * @param {function} [onload]
 */

export default class Preloader {
    constructor (query = QUERY, duration = DURATION, onload = () => {}) {    
        const el = document.querySelector(query) || document.querySelector(QUERY);
        if (!el) throw new Error('Preloader not found');

        this.document = document.documentElement;

        this.el = el;
        this.duration = duration;
        this.onload = onload;

        this.video = null;

        return this.init();
    }

    init () {
        if (this.document) this.document.classList.add('locked');

        const progress = new Promise((resolve) => {
            const video = this.el.querySelector('video');

            const finish = () => {
                this.onload();

                this.el.classList.add('finished');

                resolve();
            };

            const waitForLoad = () => {
                if (document.readyState === 'complete') {
                    if (this.duration) {
                        setTimeout(finish, this.duration);
                    } else {
                        finish();
                    }
                } else {
                    window.addEventListener('load', () => {
                        if (this.duration) {
                            setTimeout(finish, this.duration);
                        } else {
                            finish();
                        }
                    });
                }
            };

            if (video) {
                this.video = video;

                video.muted = true;
                video.autoplay = true;
                video.playsInline = true;

                video.addEventListener('playing', () => {
                    waitForLoad();
                });

                video.play().catch(() => {
                    waitForLoad();
                });
            } else {
                waitForLoad();
            }
        });

        progress.then(() => setTimeout(() => this.hide(), 1750));
    }

    hide () {
        if (this.document) this.document.classList.remove('locked');

        this.el.classList.remove('running');
        this.el.classList.add('hidden');

        if (this.video) this.video.pause();
    }
}

/**
 * Usage example
 * 
 * import Preloader from 'components/preloader';
 * 
 * new Preloader('.site-preloader', null, () => {
 *  console.log('preloader loaded');
 * });
 * 
 * OR
 * 
 * new Preloader().then(() => console.log('preloader loaded'));
 * 
 */
